export default "__VITE_ASSET__DORNxF5K__"